import { Type, type Static } from '@sinclair/typebox';
import { FIELD_LIMITS } from '../constants.js';
import { RowVersionField, SoftDeleteFields, TimestampFields, UuidSchema } from './common.js';

export const ClientSchema = Type.Object({
  id: UuidSchema,
  name: Type.String({ minLength: 1, maxLength: FIELD_LIMITS.NAME_MAX }),
  address: Type.Union([Type.String({ maxLength: FIELD_LIMITS.ADDRESS_MAX }), Type.Null()]),
  notes: Type.Union([Type.String({ maxLength: FIELD_LIMITS.NOTES_MAX }), Type.Null()]),
  isActive: Type.Boolean(),
  ...TimestampFields,
  ...SoftDeleteFields,
  ...RowVersionField,
});
export type Client = Static<typeof ClientSchema>;

export const ClientCreateSchema = Type.Object({
  name: Type.String({ minLength: 1, maxLength: FIELD_LIMITS.NAME_MAX }),
  address: Type.Optional(Type.String({ maxLength: FIELD_LIMITS.ADDRESS_MAX })),
  notes: Type.Optional(Type.String({ maxLength: FIELD_LIMITS.NOTES_MAX })),
});
export type ClientCreate = Static<typeof ClientCreateSchema>;

export const ClientUpdateSchema = Type.Object({
  name: Type.Optional(Type.String({ minLength: 1, maxLength: FIELD_LIMITS.NAME_MAX })),
  address: Type.Optional(
    Type.Union([Type.String({ maxLength: FIELD_LIMITS.ADDRESS_MAX }), Type.Null()]),
  ),
  notes: Type.Optional(
    Type.Union([Type.String({ maxLength: FIELD_LIMITS.NOTES_MAX }), Type.Null()]),
  ),
  isActive: Type.Optional(Type.Boolean()),
  rowVersion: Type.Integer({ minimum: 0 }),
});
export type ClientUpdate = Static<typeof ClientUpdateSchema>;
